import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { ServerMessagesFacade } from './server-messages.facade';
import { setInitialStoreState } from '../../../../../common';

@Injectable({ providedIn: 'root' })
export class ServerMessagesGuard  {
  constructor(private serverMessagesFacade: ServerMessagesFacade) {}

  canActivate(): Observable<boolean> | boolean {
    this.initConnectionSetupSubscription();

    return true;
  }

  canDeactivate(): Observable<boolean> | boolean {
    this.serverMessagesFacade.disconnect();
    return setInitialStoreState(this.serverMessagesFacade);
  }

  private initConnectionSetupSubscription(): void {
    this.serverMessagesFacade.setUpConnection();
  }
}
